import React from 'react';

// DEPENDENCIES
import clsx from 'clsx';
import identity from 'lodash/identity';
import startCase from 'lodash/startCase';

// BOOTSTRAP COMPONENTS
import { Col, Row } from 'react-bootstrap';

// STYLES
import styles from './activityTable.module.scss';

// MAIN COMPONENT
const ActivityTable = ({
  columns,
  data
}) => !data ? null : (
  <div className={styles.table}>
    <Row className={styles.header}>
      {columns.map(({ key, label = startCase(key), width = 24/columns.length }, i) => (
        <Col
          key={i}
          className={styles.col}
          xs={width}
        >
          <span className={styles.label}>{label}</span>
        </Col>
      ))}
    </Row>
    <div className={styles.body}>
      {data.map((rowData, i) => (
        <div key={i} className={styles.item}>
          <Row className={styles.row}>
            {columns.map(({
              key,
              as: Component = ({ children }) => children,
              width = 24/columns.length,
              className,
              classNameMethod = () => {},
              format = identity,
            }, j) => (
              <Col
                key={j}
                className={clsx('text-start', styles.col, className, classNameMethod(rowData))}
                xs={width}
              >
                <Component className="text-start" data={rowData}>{format(rowData[key]) || '-'}</Component>
              </Col>
            ))}
          </Row>
        </div>
      ))}
    </div>
  </div>
);

// EXPORT
export default ActivityTable;
